import { render, staticRenderFns } from "./OrderDialog.vue?vue&type=template&id=caaa9d46&scoped=true&"
import script from "./OrderDialog.vue?vue&type=script&lang=js&"
export * from "./OrderDialog.vue?vue&type=script&lang=js&"
import style0 from "./OrderDialog.vue?vue&type=style&index=0&id=caaa9d46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caaa9d46",
  null
  
)

export default component.exports